import {
  InternshipFunctions,
  fetchInternshipFunctions as apiFetchInternshipFunctions,
} from 'api/orgs';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch, GetState } from '..';
import { setError } from './error';

// Types

export type State = InternshipFunctions | null | undefined;

export type Action = {
  type: 'INTERNSHIP_FUNCTIONS_SET';
  internshipFunctions: InternshipFunctions | null | undefined;
};

// Reducer

export function internshipFunctionsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = null,
  action: Action
) {
  switch (action.type) {
    case 'INTERNSHIP_FUNCTIONS_SET': {
      return action.internshipFunctions;
    }

    default:
      return state;
  }
}

// Actions

export const fetchInternshipFunctions =
  () => (dispatch: Dispatch, getState: GetState) => {
    if (getState().internshipFunctions) {
      return;
    }

    apiFetchInternshipFunctions()
      .then((internshipFunctions) => {
        dispatch({
          type: 'INTERNSHIP_FUNCTIONS_SET',
          internshipFunctions,
        });
      })
      .catch(setError);
  };
